import { gfhAPI } from 'API/httpClient';

function getTrialInformation(userId: string) {
  return gfhAPI.get(`/user-trial?userId=${userId}`);
}

export default getTrialInformation;
